import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { withPermission, Roles } from "../../../util/PermissionProvider";
import ReportPage from "./ReportPage";
import ReportEditPage from "./ReportPage/editPage";


export default function ReportPages(props) {
  const { match } = props;
  return (
    <Switch>
      <Route
        exact
        path={`${match.url}`}
        component={withPermission(
          ReportPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/:id`}
        component={withPermission(
          ReportEditPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route render={() => <Redirect to={`${match.url}`} />} />
    </Switch>
  );
}
